// @ts-nocheck
import { defineComponent, computed } from 'vue';
import type { PropType } from 'vue';
import type { SVGJson, TreeObj } from '../utils/use-render';
import { renderFn, formatColor } from '../utils/use-render';
import { useNamespace } from '@nio-fe/shared';
import '../style/index.scss';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M14.04 18.59c.8 0 1.46-.66 1.46-1.47h-7c0 .81.66 1.47 1.46 1.47h4.08z"}},{"tag":"path","attrs":{"fill":"currentColor","d":"M8.65 2a1 1 0 00-.9.54L6.55 4.93H2c0 .8.66 1.46 1.46 1.46h.86l1.41 14.7a1 1 0 001 .91h10.54a1 1 0 001-.9l1.41-14.7h.86c.8 0 1.46-.66 1.46-1.47h-4.54l-1.22-2.39a1 1 0 00-.89-.54h-6.7zm7.14 2.93H8.2l.75-1.47h6.08l.75 1.47zm-8.6 15.6L5.81 6.4h12.36l-1.36 14.15H7.18z"}}]};

export default defineComponent({
  name: 'IconRubbish',
  props: {
    color: {
      type: [Array, String] as PropType<string[] | string>,
      required: false,
      default: () => [],
    },
    spin: {
      type: String as PropType<'cw' | 'ccw'>,
      required: false,
    },
    size: {
      type: [String, Number],
      required: false,
      // default: 24,
    },
    rotate: {
      type: Number,
      required: false,
    },
  },
  emits: {
    click: (evt: MouseEvent) => evt instanceof MouseEvent,
  },
  setup(props, { attrs, emit }) {
    return () => {
      const { size, color, spin, rotate } = props;
      const prefix = `${useNamespace()}-icon`.toLowerCase();

      const spinClassName = `${spin ? `${prefix}_spin-${spin}` : ''}`;
      const iconStyle = computed(() => ({
        fontSize: size,
        transform: `rotate(${rotate}deg)`,
        ...(attrs.style as StyleSheet),
      }));
      const finalColor = computed(() => formatColor(color));
      const finalClass = computed(() => [prefix, `${prefix}__rubbish`, spinClassName, attrs.class]);
      const finalProps = {
        class: finalClass.value,
        style: iconStyle.value,
        onClick: (evt: MouseEvent) => emit('click', evt),
      };

      return renderFn(element, finalProps, finalColor.value as TreeObj);
    };
  },
});
